interface IChameleonProductsAttribute {
  manage_profile: boolean
  manage_organigram: boolean
  manage_feedback: boolean
  manage_news: boolean
  manage_home: boolean
  manage_documents: boolean
  manage_publications: boolean
  manage_general_dashboard: boolean
  manage_acknowledgments: boolean
  manage_benefits: boolean
  manage_workflows: boolean
  manage_performance_results: boolean
  manage_open_survey: boolean
}

export class ChameleonProductsAttribute {
  admin_profile: boolean
  admin_organigram: boolean
  admin_feedback: boolean
  admin_news: boolean
  admin_home: boolean
  admin_documents: boolean
  admin_publications: boolean
  admin_general_dashboard: boolean
  admin_acknowledgments: boolean
  admin_benefits: boolean
  admin_workflows: boolean
  admin_performance_results: boolean
  admin_open_survey: boolean

  constructor(data: IChameleonProductsAttribute) {
    this.admin_profile = data.manage_profile
    this.admin_organigram = data.manage_organigram
    this.admin_feedback = data.manage_feedback
    this.admin_news = data.manage_news
    this.admin_home = data.manage_home
    this.admin_documents = data.manage_documents
    this.admin_publications = data.manage_publications
    this.admin_general_dashboard = data.manage_general_dashboard
    this.admin_acknowledgments = data.manage_acknowledgments
    this.admin_benefits = data.manage_benefits
    this.admin_workflows = data.manage_workflows
    this.admin_performance_results = data.manage_performance_results
    this.admin_open_survey = data.manage_open_survey
  }

  toMap() {
    const keys = Object.keys(this)
    return keys.reduce((acc, key) => {
      const value = this[key]
      if (value) acc[key] = value
      return acc
    }, {})
  }
}
